import { Link } from "react-router-dom";

export const Logo = ({ to = "/", light = false, className = "h-8 md:h-10" }) => (
  <Link to={to} state={to === "/" ? { home: true } : undefined} className="inline-flex shrink-0 items-center rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#222d99]" data-testid="brand-logo-link">
    <img src={light ? "/crowlearn-logo-light.webp" : "/crowlearn-logo.webp"} alt="Crowlearn" width="525" height="160"
      className={`w-auto ${className}`} decoding="async" data-testid="brand-logo-img" />
  </Link>
);
